// Helpers to filter / breakdown the Cash & Card list of the advanced shift report
// by selected Card Names (from settings) and Bank Journals.
// Matching is intentionally flexible so it works regardless of which identifier
// fields the backend returns on each cashAndCard row (type / cardName / vendor /
// journalName / cardId / journalId).

const norm = (v) => (v === null || v === undefined ? "" : String(v)).trim().toLowerCase();

export const rowMatchValues = (row) =>
  [row?.type, row?.cardName, row?.vendor, row?.journalName, row?.cardId, row?.journalId]
    .map(norm)
    .filter(Boolean);

export const cardMatchValues = (card) =>
  [card?.cardName, card?.journalName, card?.journalId, card?._id]
    .map(norm)
    .filter(Boolean);

export const journalMatchValues = (journal) =>
  [journal?.journalName, journal?._id, journal?.journalId]
    .map(norm)
    .filter(Boolean);

export const matchesSelection = (row, selectedCards, selectedJournals) => {
  const cardsActive = Array.isArray(selectedCards) && selectedCards.length > 0;
  const journalsActive = Array.isArray(selectedJournals) && selectedJournals.length > 0;
  if (!cardsActive && !journalsActive) return true;

  const rv = rowMatchValues(row);
  const cardHit =
    cardsActive &&
    selectedCards.some((c) => cardMatchValues(c).some((v) => rv.includes(v)));
  const journalHit =
    journalsActive &&
    selectedJournals.some((j) => journalMatchValues(j).some((v) => rv.includes(v)));
  return cardHit || journalHit;
};

// Returns the filtered rows + their summed amount.
export const getFilteredCashCard = (list, selectedCards, selectedJournals) => {
  const rows = (list || []).filter((r) => matchesSelection(r, selectedCards, selectedJournals));
  const total = rows.reduce((sum, r) => sum + (Number(r?.amount) || 0), 0);
  return { rows, total };
};

export const hasCashCardFilter = (selectedCards, selectedJournals) =>
  (Array.isArray(selectedCards) && selectedCards.length > 0) ||
  (Array.isArray(selectedJournals) && selectedJournals.length > 0);

// Groups cash & card rows by payment type (cash / card / upi ...) so the UI can
// render a type header with the per card-name / bank-journal sub-lines under it.
export const groupCashCardByType = (rows) => {
  const order = [];
  const map = {};
  (rows || []).forEach((r) => {
    const key = (r?.type || "Other").toString();
    if (!map[key]) {
      map[key] = { type: key, total: 0, items: [] };
      order.push(key);
    }
    map[key].total += Number(r?.amount) || 0;
    map[key].items.push(r);
  });
  return order.map((k) => map[k]);
};
